import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import teamFoto from './team-foto.webp';
export function WhoWeAre() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex-1"><Image src={teamFoto} alt="" className="aspect-square rounded-xl object-cover md:aspect-3/2" loading="lazy" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="fluid-container flex flex-col items-center gap-8 sm:flex-row-reverse sm:justify-between sm:gap-16">{t0}<div className="flex flex-1 flex-col gap-4"><h2 className="font-heading2">Wer wir sind</h2><p>Ein Team, eine Vision. Als junges Startup lieben wir Erlebnisse, die verbinden, bereichern und nachwirken. Echte Begegnungen und bewusste Momente – auf Reisen oder vor der Haustür. Damit sich jeder Tag ein bisschen wie Freitag anfühlt.</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}